import { useCallback, useEffect, useState } from "react";

import { useInduction } from "../../hooks/useInduction";
import { Benefit } from "../../TypesOrInterfaces/induction";

import { Container } from "./styles";
import { MyModal } from "../Modal";
export function Benefits() {
    const { store, getBenefits } = useInduction();
    const [benefits, setBenefits] = useState([] as Benefit[]);
    const [handleShow, setHandleShow] = useState(false);
    const [url, setUrl] = useState("");
    useEffect(() => {
        getBenefits().then((response) => {            
            setBenefits(response);
        });
    }, []);

    function openBenefit(benefit: Benefit) {       
        if (benefit.benefit.allowCustomMembership && benefit.benefit.allowCustomMembershipPDV) {
            window.location.href = (`/#/?benefitId=${benefit.benefit.id}`); 
            window.location.reload();               
        }
        else if (!benefit.benefit.allowCustomMembershipPDV) {
            setUrl(benefit.benefit.siteUrl.toString());
            setHandleShow(true);
        }
        else if (benefit.benefit.siteUrl) {
            window.location.href = benefit.benefit.siteUrl;
        }
    }
    function onCloseModal() {
         window.open(url, '_blank');
         setHandleShow(false); 
    };

    const onCloseModalX = useCallback(() => {
        setHandleShow(false);
    }, []);

    return (
        <Container>
            <h3>{store.tradeName}</h3>
            <div className="table">
                <div className="th">
                    <div className="td">Nome do Programa de Benefícios</div>
                    <div className="td"></div>
                </div>
                {benefits?.filter(benefit => !benefit.benefit.requiresMembership || benefit.benefit.allowCustomMembership || benefit.benefit.siteUrl)
                    .sort((a: Benefit, b: Benefit) => {
                        if (a.benefit.name < b.benefit.name)
                            return  -1;
                        else
                            return 1;
                    }).map(benefit => (
                    <div className="tr">
                        <div className="td">{benefit.benefit.name}</div>
                        <div className="td button">
                            {benefit.benefit.requiresMembership ? (
                                <button type="button" value={benefit.benefit.id} onClick={() => openBenefit(benefit)}>
                                    Novo cadastro
                                </button>
                            ) : (
                                <>
                                    Não requer cadastro
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            <MyModal 
                show={handleShow} 
                content="Para prosseguir com o cadastro, será aberto em outra guia do seu navegador o site do programa."
                onClose={onCloseModal} 
                onCloseX={onCloseModalX}
            />
        </Container>
      
    )
}